var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTripleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67 67",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "square",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M41.654 9.547l-2.949 2.95 1.475 1.474 19.357 19.357L40.18 52.686l-1.475 1.472 2.95 2.95 1.474-1.475 22.307-22.307-22.307-22.305zM4.156 22.047l-2.947 2.95 1.475 1.472 6.859 6.86-6.86 6.857L1.21 41.66l2.947 2.95 1.475-1.475 9.808-9.809-9.808-9.805z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    clipRule: "nonzero",
    overflow: "visible",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M21.863 15.797l-2.947 2.947 1.475 1.475 13.107 13.107-13.11 13.11-1.472 1.474 2.947 2.95 1.475-1.475 16.057-16.059-16.057-16.055z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    clipRule: "nonzero",
    overflow: "visible",
    fillRule: "nonzero"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleRight);
export default __webpack_public_path__ + "static/media/triple_right.043f4cde.svg";
export { ForwardRef as ReactComponent };